/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 2f4075213ce6
 */

import * as z from "zod";
import {
  UploadPresetSummary,
  UploadPresetSummary$zodSchema,
} from "./uploadpresetsummary.js";

export type UploadPresetListResponse = {
  presets: Array<UploadPresetSummary>;
  next_cursor?: string | null | undefined;
};

export const UploadPresetListResponse$zodSchema: z.ZodType<
  UploadPresetListResponse
> = z.object({
  next_cursor: z.string().nullable().optional().describe(
    "Cursor for the next page of results.",
  ),
  presets: z.array(UploadPresetSummary$zodSchema),
});
